import get from "lodash/get";
import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../Component/FloatValues";
import { ReducersTypes } from "../../../../../../../Constants";
import LeavePlan from "..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const monthlyallocate = [];
const allmonths = moment.monthsShort();
for (const month in allmonths) {
  monthlyallocate.push({
    monthid: Number(month) + 1,
    name: allmonths[month],
    value: 0,
  });
}
const ParentState = {
  leavename: "",
  leaveid: null,
  monthlyallocate,
  isallocatebalance: true,
  isautoallocation: true,
  annualbalance: 1,
  employeetype: [],
  EmploymentTypeList: [],
  employeetypeids: null,
  gender: [],
  GenderList: [],
  genderids: null,
  maritalstatus: [],
  MaritalStatusList: [],
  maritalstatusids: null,
  notUnique: false,
};
class NameLeaveAllocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.SetValues(this.props);
    this.getEmploymentType();
    this.getMaritalStatus();
    this.getGender();
    this.getMonth();
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  setHelperText = (key) => {
    this.props.setHelperText({
      helperText: this.props.Language
        ? this.props.Language.extratimepolicy[key]
        : "",
    });
  };

  componentWillReceiveProps(props) {
    console.log("props: ", props.ParentIndex, this.state.ParentIndex);
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
    if (this.state.notUnique != props.notUnique) {
      this.setState({ notUnique: props.notUnique });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    console.log("customprops", this.props);
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const { InitLeavesPolicy } = props;
      this.setState(
        {
          ParentIndex,
          leavetypeid: props.leavetypeid,
          leavename: InitLeavesPolicy.policy[ParentIndex].leavename,
          isallocatebalance:
            InitLeavesPolicy.policy[ParentIndex].isallocatebalance,
          isautoallocation:
            InitLeavesPolicy.policy[ParentIndex].isautoallocation,
          annualbalance: InitLeavesPolicy.policy[ParentIndex].annualbalance,
        },
        () => {
          this.getEmploymentType();
          this.getMaritalStatus();
          this.getGender();
          this.getMonth();
          const array1 = InitLeavesPolicy.policy[ParentIndex].monthlyallocate;
          if (array1) {
            monthlyallocate.forEach((data) => {
              const month = array1.find((x) => x.monthid == data.monthid);
              if (month) {
                data.value = month.value;
              }
            });
            if (!this.state.isautoallocation) {
              this.setState({ annualbalance: 0 });
            }
            this.setState({ monthlyallocate });
          }
        },
      );
    } else {
      const parentIndex = props.ParentIndex || 0;
      const name = get(props, `InitLeavesPolicy.details[${parentIndex}]`, "");
      this.setState(
        { ...ParentState, leavename: name && get(name, "leavetypename", "") },
        () => {
          this.getEmploymentType();
          this.getMaritalStatus();
          this.getGender();
          this.getMonth();
        },
      );
    }
  }

  getMonth() {
    instance.get(`/superuser/getmastercode/Months`).then(
      (result) => {
        this.setState(
          {
            MonthList: result.data.result,
          },
          () => { },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  getEmploymentType() {
    instance.get(`/superuser/getmastercode/EmploymentType`).then(
      (result) => {
        const policyDet = this.props.InitLeavesPolicy.policy[
          this.state.ParentIndex
        ];
        console.log("policyDet: ", policyDet);
        const EmploymentTypeList = result.data.result;
        if (EmploymentTypeList.length > 0) {
          EmploymentTypeList.unshift({ displayname: "All", displayvalue: 0 });
        }
        let ids = null;
        if (policyDet) {
          ids = policyDet.employeetypeids;
          ids = ids && ids.split(",");
        }
        this.setState(
          {
            EmploymentTypeList,
            // employeetypeids: policyDet ? typeof policyDet.employeetypeids === 'string' ? JSON.parse(policyDet.employeetypeids) : policyDet.employeetypeids : null
            employeetypeids: ids,
          },
          () => {
            const { employeetypeids } = this.state;
            const employeetype = [];
            if (employeetypeids) {
              for (const id of employeetypeids) {
                const filterObj = result.data.result.find(
                  (x) => x.displayvalue == id,
                );
                employeetype.push(filterObj);
              }
            }
            this.setState({ employeetype });
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  getMaritalStatus() {
    instance.get(`/superuser/getmastercode/MaritalStatus`).then(
      (result) => {
        const policyDet = this.props.InitLeavesPolicy.policy[
          this.state.ParentIndex
        ];
        const MaritalStatusList = result.data.result;
        if (MaritalStatusList.length > 0) {
          MaritalStatusList.unshift({ displayname: "All", displayvalue: 0 });
        }
        let ids = null;
        if (policyDet) {
          ids = policyDet.maritalstatusids;
          ids = ids && ids.split(",");
        }
        this.setState(
          {
            MaritalStatusList,
            // maritalstatusids: policyDet ? typeof policyDet.maritalstatusids === 'string' ? JSON.parse(policyDet.maritalstatusids) : policyDet.maritalstatusids : null
            maritalstatusids: ids,
          },
          () => {
            const { maritalstatusids } = this.state;
            const maritalstatus = [];
            if (maritalstatusids) {
              for (const id of maritalstatusids) {
                const filterObj = result.data.result.find(
                  (x) => x.displayvalue == id,
                );
                maritalstatus.push(filterObj);
              }
            }
            this.setState({ maritalstatus });
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  getGender() {
    instance.get(`/superuser/getgender`).then(
      (result) => {
        const policyDet = this.props.InitLeavesPolicy.policy[
          this.state.ParentIndex
        ];
        const GenderList = result.data.result;
        if (GenderList.length > 0) {
          GenderList.unshift({ displayname: "All", displayvalue: 0 });
        }
        let ids = null;
        if (policyDet) {
          ids = policyDet.genderids;
          ids = ids && ids.split(",");
        }
        this.setState(
          {
            GenderList,
            // genderids: policyDet ? typeof policyDet.genderids === 'string' ? JSON.parse(policyDet.genderids) : policyDet.genderids : null
            genderids: ids,
          },
          () => {
            const { genderids } = this.state;
            const gender = [];
            if (genderids) {
              for (const id of genderids) {
                const filterObj = result.data.result.find(
                  (x) => x.displayvalue == id,
                );
                gender.push(filterObj);
              }
            }
            this.setState({ gender });
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  handleChange(name, ...arg) {
    switch (name) {
      case "isallocatebalance": {
        this.setState(
          {
            isallocatebalance: arg[0],
            isautoallocation: null,
            annualbalance: 0,
          },
          () => {
            const monthlyallocate = [];
            const allmonths = moment.monthsShort();
            console.log("allmonths: ", allmonths);
            for (const month in allmonths) {
              monthlyallocate.push({
                monthid: Number(month) + 1,
                name: allmonths[month],
                value: 0,
              });
            }
            console.log("monthlyallocate: ", monthlyallocate);
            this.setState({ monthlyallocate }, () => this.UpdateReducer());
          },
        );
        break;
      }
      case "isautoallocation": {
        this.setState({ isautoallocation: arg[0], annualbalance: 0 }, () => {
          const monthlyallocateres = [];
          const allmonths = moment.monthsShort();
          console.log("allmonths: ", allmonths);
          for (const month in allmonths) {
            console.log("month: ", month);
            monthlyallocateres.push({
              monthid: Number(month) + 1,
              name: allmonths[month],
              value: 0,
            });
          }
          console.log("monthlyallocateres: ", monthlyallocateres);
          this.setState({ monthlyallocate: monthlyallocateres }, () =>
            this.UpdateReducer());
        });
        break;
      }
      case "employeetype":
      case "maritalstatus":
      case "gender": {
        let filterObj = arg[0] && arg[0].findIndex((x) => x.displayvalue == 0);
        if (filterObj != null && filterObj >= 0) {
          switch (name) {
            case "employeetype":
              filterObj = this.state.EmploymentTypeList.filter(
                (x) => x.displayvalue != 0,
              );
              break;
            case "maritalstatus":
              filterObj = this.state.MaritalStatusList.filter(
                (x) => x.displayvalue != 0,
              );
              break;
            case "gender":
              filterObj = this.state.GenderList.filter(
                (x) => x.displayvalue != 0,
              );
              break;
            default:
              break;
          }
          this.setState({ [name]: filterObj }, () => {
            this.multiOptions(name, filterObj);
          });
        } else {
          this.setState({ [name]: arg[0] && arg.length > 0 ? arg[0] : [] }, () => {
            this.multiOptions(name, arg[0] && arg.length > 0 ? arg[0] : []);
          });
        }
        break;
      }
      case "manualannualbalance": {
        if (
          !(Number(arg[1].target.value) > Number(arg[1].target.max))
          || !Number.isNaN(arg[1].target.value)
        ) {
          const monthlyallocate1 = this.state.monthlyallocate;
          monthlyallocate1[arg[0]].value = Number(arg[1].target.value);
          console.log("monthlyallocate1: ", monthlyallocate1);
          this.setState(
            {
              monthlyallocate: monthlyallocate1,
            },
            () => this.UpdateReducer(),
          );
        }
        break;
      }
      default:
        break;
    }
  }

  calculateBalance = () => {
    let balance = 0;
    for (const month of this.state.monthlyallocate) {
      balance = month.value + balance;
    }
    return balance;
  };

  options(name, selected) {
    let arg = selected[0];
    arg = arg ? arg.displayvalue : null;
    switch (name) {
      case "othercreditmodetype": {
        this.setState({ othercreditmodetypeid: arg }, () =>
          this.UpdateReducer());
        break;
      }
      default:
        break;
    }
  }

  multiOptions(name, arg) {
    const obj = [];
    for (const val of arg) {
      obj.push(val.displayvalue);
    }
    switch (name) {
      case "employeetype":
        this.setState({ employeetypeids: obj }, () => this.UpdateReducer());
        break;
      case "gender":
        this.setState({ genderids: obj }, () => this.UpdateReducer());
        break;
      case "maritalstatus":
        this.setState({ maritalstatusids: obj }, () => this.UpdateReducer());
        break;
      default:
        break;
    }
  }

  UpdateReducer = () => {
    const { ParentIndex, leavename } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    const { isautoallocation } = this.state;
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      leavename,
      isallocatebalance: this.state.isallocatebalance,
      isautoallocation,
      annualbalance: isautoallocation
        ? this.state.annualbalance
        : this.calculateBalance(),
      employeetypeids: this.state.employeetypeids
        ? this.state.employeetypeids.join()
        : this.state.employeetypeids,
      genderids: this.state.genderids
        ? this.state.genderids.join()
        : this.state.genderids,
      maritalstatusids: this.state.maritalstatusids
        ? this.state.maritalstatusids.join()
        : this.state.maritalstatusids,
      monthlyallocate: this.state.monthlyallocate,
    };

    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max)
        || Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = Number(event.target.value);
      this.setState({ [name]: value }, () => {
        if (name != "annualbalance") {
          this.UpdateReducer();
        } else {
          const { monthlyallocate } = this.state;
          const eachMonth = this.state.annualbalance / 12;
          for (const month of monthlyallocate) {
            month.value = eachMonth;
          }
          this.setState({ monthlyallocate }, () => {
            this.UpdateReducer();
          });
        }
      });
    }
  };

  checkUnique() {
    const { InitLeavesPolicy, enqueueSnackbar } = this.props;
    const { ParentIndex, leavename } = this.state;
    if (leavename || leavename != "") {
      if (
        leavename.includes("employeename")
        || leavename.includes("employeecode")
        || leavename.includes("designation")
        || leavename.includes("department")
        || leavename.includes("businessunit")
      ) {
        enqueueSnackbar("Please enter valid leave name", {
          variant: "error",
        });
        this.setState({ notUnique: true }, () => {
          if (
            this.props.InitLeavesPolicy.policy[ParentIndex]
            && this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
          ) {
            this.UpdateReducer();
          }
        });
      } else if (
        this.props.InitLeavesPolicy.policy[ParentIndex]
            && this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
      ) {
        this.UpdateReducer();
      } else {
        instance
          .post("/leaves/uniqueleavename", {
            leavename,
            leavetypeid: InitLeavesPolicy.details[ParentIndex].leavetypeid,
            leavecategoryid:
              InitLeavesPolicy.details[ParentIndex].leavecategoryid,
            leaveid: this.props.InitLeavesPolicy.policy[ParentIndex]
              ? this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
              : null,
          })
          .then(() => {
            this.setState({ notUnique: false }, () => this.UpdateReducer());
          })
          .catch((error) => {
            this.setState({ notUnique: true });
            enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              {
                variant: "error",
              },
            );
          });
      }
    } else {
      this.setState({ notUnique: true }, () => {
        if (
          this.props.InitLeavesPolicy.policy[ParentIndex]
          && this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
        ) {
          this.UpdateReducer();
        }
      });
    }
  }

  onNameChange(event) {
    this.setState({ leavename: event.target.value });
    if (this.props.ChangeSteppername) {
      this.props.ChangeSteppername(event.target.value, this.props.ParentIndex);
    }
  }

  validateNext() {
    this.checkUnique();
    if (!this.state.leavename || this.state.leavename == "") {
      this.setState({ notUnique: true });
    } else {
      this.props.click();
    }
  }

  render() {
    const language = this.props.Language.extratimepolicy;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          {/* <p class="input-form-label">
                    </p> */}
          <div className="inner-wrapper opaque">
            <div className="form-group ">
              <p className="form-main-header">
                <FormattedMessage
                  id="LbleaveName"
                  defaultMessage="Let’s give this leave a name"
                />
              </p>
              <div>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  maxLength={50}
                  // autoFocus
                  placeholder="Leave Name"
                  onChange={this.onNameChange.bind(this)}
                  value={this.state.leavename}
                  onBlur={this.checkUnique.bind(this)}
                />
                <br />
                {this.state.notUnique ? (
                  <span className="caption-error leave-policy-error">
                    This doesn&apos;t look like a valid leave name
                  </span>
                ) : null}
              </div>
            </div>
          </div>
          {/* 1 */}
          <div>
            <p className="form-main-header">
              <FormattedMessage
                id="LbLeaveAllocation"
                defaultMessage="Leave Allocation"
              />
            </p>
            <div className="inner-wrapper opaque">
              <div className="">
                <p className="depedent-select-list-head">
                  How do you want to define annual allotment of leave balance?
                </p>
                {/* <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isallocatebalance", true)}
                  aria-expanded={this.state.isallocatebalance}
                >
                  <span>
                    <FormattedMessage
                      id="LbYes"
                      defaultMessage="Yes, allot limited leave balance"
                    />
                  </span>
                  {this.state.isallocatebalance == true ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div> */}
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isautoallocation", true)}
                  aria-expanded={this.state.isautoallocation}
                >
                  <span>Automatically allocate annual leave balance</span>
                  {this.state.isautoallocation ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                      <span className="not-selected " />
                    )}
                </div>
                <Collapse
                  in={this.state.isautoallocation}
                  timeout="auto"
                  unmountOnExit
                  className="et-level2"
                // className="padding30 overflow-initial"
                >
                  <div className="depedent-select-list">
                    <span className="width100p">
                      <InputValues
                        min="1"
                        max="365"
                        field="annualbalance"
                        onChange={this.CommonNumberChange.bind(
                          this,
                          "annualbalance",
                          365,
                        )}
                        value={this.state.annualbalance}
                        defaultvalue={this.state.annualbalance}
                        disabled={!this.state.isautoallocation}
                      />{" "}
                      days
                    </span>
                  </div>
                </Collapse>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isautoallocation", false)}
                  aria-expanded={!this.state.isautoallocation}
                >
                  <span>Manually allocate leave balance per month</span>
                  {!this.state.isautoallocation ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                      <span className="not-selected " />
                    )}
                </div>
                <Collapse
                  in={!this.state.isautoallocation}
                  timeout="auto"
                  unmountOnExit
                  className="et-level2"
                // className="padding30 overflow-initial"
                >
                  <div className="inlindClass">
                    {!this.state.isautoallocation
                      && this.state.monthlyallocate.map(
                        (data, index) =>
                          // const month = this.state.monthlyallocate.find(month => month.monthid == data.mon)
                          !this.state.isautoallocation && (
                            <div className="annual-leave-balance">
                              <div className="padding-left-8">{data.name}</div>
                              <span className="number-wrapper">
                                <InputValues
                                  className="seatlimit"
                                  type="number"
                                  min="0"
                                  max="28"
                                  onChange={this.handleChange.bind(
                                    this,
                                    "manualannualbalance",
                                    index,
                                  )}
                                  // step=".01"
                                  value={data.value}
                                  disabled={this.state.isautoallocation}
                                />
                              </span>
                              {/* {(index == 3 || index == 7) && <br />} */}
                            </div>
                          ),
                      )}
                    <br />
                    <div className="margin-bottom-16 margin-left-10">
                      <div className="padding-left-8">
                        <strong>Total</strong>
                      </div>
                      <span className="">
                        {!this.state.isautoallocation && (
                          <input
                            className="seatlimit"
                            type="number"
                            value={this.calculateBalance()}
                            disabled={true}
                          />
                        )}
                      </span>
                    </div>
                  </div>
                </Collapse>

                {/** here */}
                <div className="et-level2 display-none">
                  <Collapse
                    in
                    // in={this.state.isallocatebalance}
                    timeout="auto"
                    unmountOnExit
                    className="padding30 overflow-initial"
                  >
                    <div
                      className="depedent-select-list"
                      aria-expanded={this.state.isautoallocation}
                    >
                      <FormattedMessage
                        id="LbAutoAllocate"
                        defaultMessage="Automatically allocate"
                      />
                      <span className="width100p">
                        <InputValues
                          min="1"
                          max="365"
                          field="annualbalance"
                          onChange={this.CommonNumberChange.bind(
                            this,
                            "annualbalance",
                            365,
                          )}
                          value={this.state.annualbalance}
                          defaultvalue={this.state.annualbalance}
                          disabled={!this.state.isautoallocation}
                        />
                      </span>
                      <FormattedMessage
                        id="LbAnnualLeaveBalance"
                        defaultMessage="annual leave balance"
                      />
                      <span
                        onClick={() =>
                          this.handleChange("isautoallocation", true)
                        }
                      >
                        {this.state.isautoallocation == true ? (
                          <span className="floatright margin-top-20">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                            <span className="not-selected margin-top-20" />
                          )}
                      </span>
                    </div>
                    <div
                      className="depedent-select-list"
                      aria-expanded={!this.state.isautoallocation}
                    >
                      <span> Manually allocate leave balance per month</span>
                      <span
                        onClick={() =>
                          this.handleChange("isautoallocation", false)
                        }
                      >
                        {!this.state.isautoallocation ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                            <span className="not-selected" />
                          )}
                      </span>
                    </div>
                    <div className="et-level3">
                      <Collapse
                        in={this.state.isautoallocation == false}
                        timeout="auto"
                        unmountOnExit
                        className="padding30 overflow-initial"
                      >
                        <div className="inlindClass">
                          {this.state.monthlyallocate.map((data, index) => (
                            // const month = this.state.monthlyallocate.find(month => month.monthid == data.mon)
                            <div className="annual-leave-balance">
                              <div className="padding-left-8">
                                {data.name}22
                              </div>
                              <span className="number-wrapper">
                                <InputValues
                                  className="seatlimit"
                                  type="number"
                                  min="0"
                                  max="28"
                                  onChange={this.handleChange.bind(
                                    this,
                                    "manualannualbalance",
                                    index,
                                  )}
                                  value={data.value}
                                  disabled={this.state.isautoallocation}
                                  // step=".01"
                                />
                              </span>
                              {(index == 3 || index == 7) && <br />}
                            </div>
                          ))}
                          <br />
                          <div className="margin-bottom-16 margin-left-10">
                            <div className="padding-left-8">
                              <strong>Total</strong>
                            </div>
                            <span className="">
                              <input
                                className="seatlimit"
                                type="number"
                                value={this.calculateBalance()}
                                disabled={true}
                              />
                            </span>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
          </div>
          {/* 2 */}
          <div className="margin-top-20">
            <p className="form-main-header">
              <FormattedMessage
                id="LbWhoHowWhen"
                defaultMessage="Who, How & When (Calculations & Disbursal)"
              />
            </p>
            <p className="form-sub-header">
              <FormattedMessage
                id="LbWhocanAvail"
                defaultMessage="Who can avail this leave balance?"
              />
            </p>
            <div className="inner-wrapper opaque">
              <div className="margin-bottom-20 width50">
                <p className="depedent-select-list-head">
                  <FormattedMessage id="LbGender" defaultMessage="Gender" />
                </p>
                <Select
                  class="form-control width50"
                  autofocus
                  placeholder="Select Gender"
                  isMulti
                  options={this.state.GenderList}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.handleChange.bind(this, "gender")}
                  value={this.state.gender}
                />
              </div>
              <div className="margin-bottom-20 width50">
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbEmploymentType"
                    defaultMessage="Employment Type"
                  />
                </p>
                <Select
                  class=" form-control"
                  autofocus
                  placeholder="Select Employment Type"
                  isMulti
                  options={this.state.EmploymentTypeList}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.handleChange.bind(this, "employeetype")}
                  value={this.state.employeetype}
                />
              </div>
              <div className="margin-bottom-20 width50">
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbMaritalStatus"
                    defaultMessage="Marital Status"
                  />
                </p>
                <Select
                  class=" form-control"
                  autofocus
                  placeholder="Select Marital Status"
                  isMulti
                  options={this.state.MaritalStatusList}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.handleChange.bind(this, "maritalstatus")}
                  value={this.state.maritalstatus}
                />
              </div>
            </div>
          </div>
          {/* <Button variant="contained" color="primary" onClick={() => this.validateNext()}>
                        Next
                    </Button> */}
        </div>
      </IntlProvider>
    );
  }
}
NameLeaveAllocation.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(NameLeaveAllocation)));
